import React, { useEffect, useMemo } from 'react';

import { useBeneficiaries } from 'hooks/useBeneficiaries';

import { calculateAge } from 'helpers/utils';
import useBranchPermission from 'hooks/useBranchPermission';

import { BENEFICIARY_STATUS_UNSPONSORED } from './beneficiary-form/BeneficiaryForm';

import LoadingContainer from 'components/common/LoadingContainer';
import SponsorshipList from './sponsorship-content/SponsorshipList';

const UnSponsoredList = () => {
  const { beneficiaries, isLoading: loading } = useBeneficiaries();

  // Filter for unsponsored beneficiaries
  const unsponsoredBeneficiaries = useMemo(
    () =>
      beneficiaries?.filter(
        // grey statuses = left the programme: not listed here
        b =>
          b.status === BENEFICIARY_STATUS_UNSPONSORED &&
          !b.sponsorship_status?.is_hidden
      ) || [],
    [beneficiaries]
  );

  const beneficiariesData = useMemo(
    () =>
      unsponsoredBeneficiaries.map(
        ({
          id,
          simple_id,
          first_name,
          middle_name,
          last_name,
          DOB,
          country,
          sponsorship_priority,
          duration,
          sponsorship_type,
          gender
        }) => ({
          id,
          simpleId: simple_id,
          name: `${first_name} ${middle_name ?? ''} ${last_name}`,
          age: calculateAge(DOB),
          location: country,
          sponsor: '-',
          renewal: ' -',
          priority: sponsorship_priority?.priority_type,
          duration,
          type: sponsorship_type?.type,
          gender
        })
      ) ?? [],
    [unsponsoredBeneficiaries]
  );

  if (loading) return <LoadingContainer />;

  return (
    <SponsorshipList
      data={beneficiariesData}
      title="Unsponsored"
      initialLayout="cardview"
    />
  );
};

export default UnSponsoredList;
